export default {"card":"Sh57g","cardHeader":"vR64t","tagWrapper":"g8BP0","tag":"bHgn3","cardButton":"VbKVZ"};